import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { EnrollmentViewModel } from '../../../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../../../gateways/enrollment-gateway'
import { SetEnrollmentDataPdf } from '../../../../models/set-enrollment-data-pdf'
import { EnrollmentData } from '../../../../models/enrollment-data'
import * as moment from 'moment'
import { PortalGlobals } from '../../../../../portalglobals'
import { CurrentUserGateway } from '../../../../../common/gateways/current-user-gateway'
@Component({
    selector: 'PhoneEnrollmentExtFinal',
    templateUrl: 'phone-enrollment-final.component.html',
    styleUrls: ['../phone-enrollment.component.scss']
})
export class PhoneEnrollmentExtFinalComponent implements OnInit {
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    confirmationNumber: string
    effectiveDate: string
    insuranceComapny: string
    setPdf: SetEnrollmentDataPdf = {} as SetEnrollmentDataPdf
    enrollmentJson: EnrollmentData
    spnYouenrollee: string
    spnYourenrollee: string
    spnyouthem: string
    spnIsBeneficiaryYour: string
    spnyouhisher: string
    AgentFullName: string
    selectedPlanYear: number
    ShowCurrentYearScript: boolean = false

    constructor(
        public _global: PortalGlobals,
        private router: Router,
        private _enrollementGateway: EnrollmentGateway,
        private _currentUserGateway: CurrentUserGateway
    ) {
        this.enrollment = {} as EnrollmentViewModel
        this.setPdf = {} as SetEnrollmentDataPdf
    }

    ngOnInit() {
        if (this._global === undefined || this._global.currentUser === undefined) {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this._global.currentUser = user
                    this.insuranceComapny = this._global.currentUser.insuranceCompanyName
                }
            })
        }
        if (this._global.currentUser !== undefined) {
            this.insuranceComapny = this._global.currentUser.insuranceCompanyName
        }
        if (Number(this._global.selectedPlanYear) === this._global.PreviousPlanYear) {
            this.ShowCurrentYearScript = true
        }
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        this.AgentFullName =
            (this.enrollment.APPFN === null ? '' : this.enrollment.APPFN) + ' ' + (this.enrollment.APPLN === null ? '' : this.enrollment.APPLN)
        this.setScript()
        sessionStorage.setItem('enrollmentViewModel', JSON.stringify(this.enrollment))
        localStorage.setItem('enrollmentViewModel', JSON.stringify(this.enrollment))

        if (this.enrollment !== undefined && this.enrollment.CONF !== undefined) {
            this.confirmationNumber = this.enrollment.CONF
        }
        if (this.enrollment !== undefined && this.enrollment.EFFDT !== undefined) {
            this.effectiveDate = moment(this.enrollment.EFFDT).format('MM/DD/YYYY')
        }
    }

    enrollNew(): void {
        this.enrollment = {} as EnrollmentViewModel
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/ext/Step1'])
    }
    enrollSameAddress(): void {
        let ADD1 = this.enrollment.APPADD1
        let ADD2 = this.enrollment.APPADD2
        let CITY = this.enrollment.APPCITY
        let ST = this.enrollment.APPST
        let ZIP = this.enrollment.APPZIP

        let MAILADD1 = this.enrollment.MAILADD1
        let MAILADD2 = this.enrollment.MAILADD2
        let MAILCITY = this.enrollment.MAILCITY
        let MAILST = this.enrollment.MAILST
        let MAILZIP = this.enrollment.MAILZIP
        this.enrollment = {} as EnrollmentViewModel

        this.enrollment.APPADD1 = ADD1
        this.enrollment.APPADD2 = ADD2
        this.enrollment.APPCITY = CITY
        this.enrollment.APPST = ST
        this.enrollment.APPZIP = ZIP

        this.enrollment.MAILADD1 = MAILADD1
        this.enrollment.MAILADD2 = MAILADD2
        this.enrollment.MAILCITY = MAILCITY
        this.enrollment.MAILST = MAILST
        this.enrollment.MAILZIP = MAILZIP

        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/ext/Step1'])
    }

    SavePdf(): void {
        //if (this.enrollment.EOB !== undefined) {
        //    //if (this.enrollment.EOB.toString().toUpperCase() === 'EEOB') {
        //    if (this.enrollment.EOB === '3') {
        //        this.enrollment.EOB = 'Yes'
        //    } else {
        //        this.enrollment.EOB = 'No'
        //    }
        //}
        //else {
        //    this.enrollment.EOB = ''
        //}
        if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== null)
            this.selectedPlanYear = this._global.selectedPlanYear
        else this.selectedPlanYear = 2021

        this._enrollementGateway
            .generatePDF(this.enrollment, this._global.currentUser.insuranceCompanyName, this.selectedPlanYear)
            .subscribe((model: any) => {
                console.log(model)
                var binaryString = window.atob(model)
                var binaryLen = binaryString.length
                console.log('binaryLen' + binaryLen)
                if (binaryLen == 3) {
                    console.log('File doesnt exist / some back ground  error')
                    // this.downloadError = 'File Not Found'
                    return
                }
                //  this.downloadError = ''
                var bytes = new Uint8Array(binaryLen)
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i)
                    bytes[i] = ascii
                }

                let fileName = this.enrollment.APPLN + '-' + this.enrollment.APPFN + '.pdf'
                // below code needed for ie browser
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    ;(window.navigator as any).msSaveBlob(new Blob([bytes], { type: 'application/pdf' }), fileName)
                }
                // for other browsers
                var fileURL = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }))
                // window.open(fileURL)
                var link = document.createElement('a')
                link.setAttribute('href', fileURL)
                link.setAttribute('download', fileName)
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
    }

    setScript() {
        if (this.enrollment.RBLBENFE === 'Yes') {
            this.spnIsBeneficiaryYour = 'your '

            this.spnYouenrollee = 'You'
            this.spnYourenrollee = 'Your'
            this.spnyouhisher = 'you'
            this.spnyouthem = 'you'
        }
        if (
            this.enrollment.RBLBENFE === 'No' &&
            this.AgentFullName !== ' ' &&
            this.AgentFullName !== '' &&
            this.AgentFullName !== 'undefined undefined'
        ) {
            this.spnIsBeneficiaryYour = 'enrollee’s'

            this.spnYouenrollee = 'The enrollee'
            this.spnYourenrollee = 'Enrollee’s'

            if (this.enrollment.TITLE === 'Mr' || this.enrollment.APPGEN === 'M') {
                this.spnyouhisher = 'him'
                this.spnyouthem = 'them'
            } else if (this.enrollment.TITLE === 'Mrs' || this.enrollment.TITLE === 'Ms' || this.enrollment.APPGEN === 'F') {
                this.spnyouhisher = 'her'
                this.spnyouthem = 'them'
            } else {
                this.spnyouhisher = '(him/her)'
                this.spnyouthem = 'them'
            }
        }
        if (
            this.enrollment.RBLBENFE === 'No' &&
            (this.AgentFullName === ' ' || this.AgentFullName === 'undefined undefined' || this.AgentFullName === '')
        ) {
            this.spnIsBeneficiaryYour = '(your, enrollee’s)'

            this.spnYouenrollee = '(You, the enrollee)'
            this.spnYourenrollee = '(Your, enrollee’s)'
            this.spnyouhisher = '(you/him/her)'
            this.spnyouthem = 'them'
        }
    }
}
